const initialState = {
  loading: true,
  totalStudents: 0,
  max: 0,
  initialFetchIsDone: false,
  totalLessons: 0,
  avatarError: null,
};

export default initialState;
